import React from "react";
import { styled } from "@mui/material/styles";
import { LinearProgress } from "@mui/material";

import {
  calculateProgressAfterCheckout,
  calculateProgressBeforeCheckout,
} from "./utils/progressUtils";

const PREFIX = "ProgressBar";

const classes = {
  barRoot: `${PREFIX}-barRoot`,
};

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: "100%",
  height: theme.spacing(0.5),
  backgroundColor: theme.palette.primary.dark,
  zIndex: 100,
  position: "fixed",
  top: 0,
  boxShadow: "0px 3px 33px 5px rgba(0,0,0,0.2)",

  [`& .${classes.barRoot}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const pageNumMap = {
  SelectDeliveryMethod: 1,
  SelectDeliveryDate: 1.45,
  DeliveryAddress: 1.66,
  CustomerContactInfo: 2,
  SelectPaymentMethod: 3,
  OrderConfirmation: 4,
  PayNowPayment: 5,
  CashPayment: 5,
  PaymentComplete: 5,
};

const productPageNumMap = {
  ProductDescription: -2,
  SelectVariant: -1,
};

const ProgressBar = ({ page, total, section }) => {
  return (
    <StyledLinearProgress
      classes={{ barColorPrimary: classes.barRoot }}
      variant="determinate"
      value={
        section && section === "beforecheckout"
          ? calculateProgressBeforeCheckout(productPageNumMap[page] || page, total)
          : calculateProgressAfterCheckout(pageNumMap[page], total)
      }
      color="primary"
    />
  );
};

export default ProgressBar;
